import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {MenuInterface} from "@/api/Settings/MenuSettings/MenuInterfaces";
import {GetCurrentUserMenuApiSlice} from "@/api/Settings/MenuSettings/CurrentUserMenu/GetCurrentUserMenuApiSlice";
import {RootState} from "@/store/Store";

interface MenuSliceInterface {
    menu: Omit<MenuInterface, "active">[] | null;
}

export const MenuSlice = createSlice({
    name: "MenuSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => {
            return getInitialState()
        },
        setMenu: (state, action: PayloadAction<MenuSliceInterface["menu"]>) => {
            state.menu = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(GetCurrentUserMenuApiSlice.endpoints.getCurrentUserMenu.matchFulfilled, (state, action) => {
            state.menu = action.payload.data;
        })
    }
})

function getInitialState(): MenuSliceInterface {
    return {
        menu: null,
    }
}

export const {
    reset,
    setMenu,
} = MenuSlice.actions;

export const MenuSelectors = {
    menu: (state: RootState) => state.menu.menu
}

export const MenuReducer = MenuSlice.reducer;
